export default {
  Notifications: {
    TRANSACTIONS: 'New Transactions',
    NEW_TRANSACTIONS:
      'There are new transactions for {{date}}, requiring a re-calculation and re-posting of {{date}}’s recharges.',
    NEW_TRANSACTIONS_LOADING:
      'There are new transactions, requiring a re-calculation and re-posting of your recharges.',
    VIEW_CALCULATION: "View {{date}}'s Calculations",
    VIEW_CALCULATION_LOADING: 'View Calculation',
    VIEW_ACCOUNTS: 'View Intercompany Balances',
    FX_MOVEMENT:
      'The USD/GBP exchange rate has moved, requiring an adjustment to the intercompany balance between {{lender}} and {{borrower}}.',
    READ: 'Mark as read',
    UNREAD: 'Mark as unread',
    NO_NOTIFICATIONS: "No notifications today. You're up to date!",
  },
};
